
/**
 * 判空
 * @param data 转换的字符串
 * @return {Boolean} 空=>true 非空=>false
 */
function isEmpty(data) {
    if(data === ''){
      return true;
    }else if(data === null){
      return true;
    }else if(data === undefined){
      return true;
    }else{
      return false;
    }
};

/**
 * 时间戳转换
 * @param val 需要转换的时间戳
 * @return {String} 2020-11-01 00:00:00格式的时间字符串
 */
function timetamp(val){
    var date = new Date(val);
    var YY = date.getFullYear() + "-";
    var MM =
      (date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) + "-";
    var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    var hh =
      (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
    var mm =
      (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
      ":";
    var ss =
      date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
    return YY + MM + DD + " " + hh + mm + ss;
};

/**
 * 正则去除全部特殊字符
 * @param data 转换的字符串
 * @return {String} 去除特殊字符后的字符串
 */
function removalSpace(data){
    let patrn = /[`~!@#$^&*+()=|{}':;',\\\[\]\<>\/?~！@#￥%“”《》’‘……&*（）——|{}【】'；：""'。，、？\s]/g;
    return data = data.replace(patrn,'');
}

/**
 * 校验是否存在特殊字符
 * @param data 转换的字符串
 * @return {Boolean} 包含特殊字符=>false 未包含=>true
 */
function specialCharacters(data){
  let patrn = /[`~!@#$^&*+()=|{}':;',\\\[\]\<>\/?~！@#￥%“”《》’‘……&*（）——|{}【】'；：""'。，、？\s]/g;
  if (!patrn.test(data)) {
    return false;
  }else{
    return true;
  }
}

/**
 * 校验是否存在特殊字符
 * @param data 转换的字符串 / 数字
 * @return {Boolean} 是否是数字 非数字=>false 数字=>true 为空 => true
 */
function checkNumber(data) {
  var reg =  /^((([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/;
  if (reg.test(data)) {
    return true;
  }else if(data ===''){
    return true;
  }else if(data === null){
    return true;
  }else if(data === undefined){
    return true;
  }else{
    return false;
  }
}

function account_type_error(code) {//业务不存在
  var popwin = $('#account_type_error_123');
  var isInner = [40004, 40005, 40006].indexOf(code) > -1;
  if(popwin.length > 0){
    isInner ? popwin.show() : popwin.show().next().show();
  }else{
    var msg =
      code == 40004 ? '无当前菜单权限！' :// 无权限访问菜单
      code == 40005 ? '无当前菜单权限！' :// 无登录态
      code == 40006 ? '无当前菜单权限！' :// 鉴权失败
      code == '1400' ? '无当前系统操作权限！' :// 租户不存在
      code == '1406' ? '无当前系统操作权限！' :// 运营不存在
      code == '1401' ? '无当前系统操作权限！' :// 租户已失效
      code == '1409' ? '无当前系统操作权限！' : // 租户管理员状态无效
      code == '2406' ? '无当前系统操作权限！' : // 创作者账号已冻结
      code == '2407' ? '无当前系统操作权限！' : // 创作者审核被驳回
                                  '系统出错！';
    // 不覆盖菜单和头部,只覆盖内容部分
    if(isInner){
      popwin = $(`<div id="account_type_error_123">
        <div style="position:absolute;top:0;left:0;width:100%;height:100%;background:#000;opacity:.75;z-index:10;"></div>
        <div style="position:absolute;top:50%;left:50%;transform: translate(-50%, -50%);width:400px;height:200px;background:#fff;z-index:11;">
          <p style="padding:30px 20px 20px 20px;line-height: 30px;font-size: 16px;">${msg}</p>
        </div>
      </div>`);
      $('.content').append(popwin)
    }else{
      popwin = $(`<div id="account_type_error_123" role="dialog" aria-modal="true" aria-label="系统提示" class="el-message-box__wrapper" style="z-index: 200001;">
        <div class="el-message-box">
          <div class="el-message-box__header">
            <div class="el-message-box__title">
              <span>系统提示</span>
            </div>
          </div>
          <div class="el-message-box__content">
            <div class="el-message-box__container">
              <div class="el-message-box__message">
                <p>${msg}</p>
              </div>
            </div>
            <div class="el-message-box__errormsg" style="visibility: hidden;"></div>
          </div>
          <div class="el-message-box__btns">
            <button type="button" onclick="sessionStorage.removeItem('tenantId');location.href='/index';" class="el-button el-button--default el-button--small el-button--primary">
              <span>确定</span>
            </button>
          </div>
        </div>
      </div>`);
      $('body').append(popwin).append('<div class="v-modal" tabindex="0" style="z-index: 2000;"></div>');
    }
  }
}


/**
 * 区分文章类型函数
 * @param actionType 转换的字符串 / 数字
 * @return {String} 文章类型名称
 */
function actionTypeCheck (actionType) {
  let res = ''
  switch(actionType) {
    case '8': 
      res = '疾病';
      break;
    case '9':
      res = '症状';
      break;
    case '13':
      res = '药品';
      break;
    case '16':
      res = '疫苗';
      break;
    case '17':
      res = '保健';
      break;
    default: 
      break;
  }
  return res;
}

export default {
    isEmpty,
    timetamp,
    removalSpace,
    specialCharacters,
    checkNumber,
    account_type_error,
    actionTypeCheck,
}
